
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7391"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7391"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gdh9t", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $bcdb2a40a2e0831a$export$6503ec6e8aabbaf; }, function (v) { return $bcdb2a40a2e0831a$export$6503ec6e8aabbaf = v; });
var $bcdb2a40a2e0831a$export$6503ec6e8aabbaf;
var $bcdb2a40a2e0831a$export$f7ad0328861e2f03;
"use strict";
var $bcdb2a40a2e0831a$var$mapping = new Map();
function $bcdb2a40a2e0831a$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$bcdb2a40a2e0831a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $bcdb2a40a2e0831a$var$resolve(id) {
    var resolved = $bcdb2a40a2e0831a$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$bcdb2a40a2e0831a$export$6503ec6e8aabbaf = $bcdb2a40a2e0831a$var$register;
$bcdb2a40a2e0831a$export$f7ad0328861e2f03 = $bcdb2a40a2e0831a$var$resolve;

});

parcelRegister("7NIms", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $5adf853cbbb05a06$export$bdfd709ae4826697; }, function (v) { return $5adf853cbbb05a06$export$bdfd709ae4826697 = v; });
$parcel$export(module.exports, "getOrigin", function () { return $5adf853cbbb05a06$export$5a759dc7a1cfb72a; }, function (v) { return $5adf853cbbb05a06$export$5a759dc7a1cfb72a = v; });
var $5adf853cbbb05a06$export$bdfd709ae4826697;
var $5adf853cbbb05a06$export$c9e73fbda7da57b6;
var $5adf853cbbb05a06$export$5a759dc7a1cfb72a;
"use strict";
var $5adf853cbbb05a06$var$bundleURL = {};
function $5adf853cbbb05a06$var$getBundleURLCached(id) {
    var value = $5adf853cbbb05a06$var$bundleURL[id];
    if (!value) {
        value = $5adf853cbbb05a06$var$getBundleURL();
        $5adf853cbbb05a06$var$bundleURL[id] = value;
    }
    return value;
}
function $5adf853cbbb05a06$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $5adf853cbbb05a06$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $5adf853cbbb05a06$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $5adf853cbbb05a06$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$5adf853cbbb05a06$export$bdfd709ae4826697 = $5adf853cbbb05a06$var$getBundleURLCached;
$5adf853cbbb05a06$export$c9e73fbda7da57b6 = $5adf853cbbb05a06$var$getBaseURL;
$5adf853cbbb05a06$export$5a759dc7a1cfb72a = $5adf853cbbb05a06$var$getOrigin;

});

var $18463ff5a914f1bc$exports = {};


(parcelRequire("gdh9t")).register((parcelRequire("7NIms")).getBundleURL("9Ksel"), JSON.parse('["9Ksel","index.1f1495c7.js","4cvKi","ticker.7b56a5df.js","bGRlQ","index.7df55e91.css"]'));


//# sourceMappingURL=index.runtime.4c4e3559.js.map
